export default __webpack_public_path__ + "assets/50b29c9aec5502130c10da25e40422e8.png";